module.exports = __webpack_public_path__ + "img/SecondaryHaversianRemodeling.e3f4130a.png";